<template>
  <div class="view-share-award">
    <div class="title">更多惊喜大礼 正在抽奖</div>
    <div class="swiper-outer">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(card, index) in awardList"
            :key="index"
          >
            <com-award-card :card-item="card"></com-award-card>
          </div>
        </div>
      </div>
    </div>
    <p class="desc-1">我在小黑盒0元抽奖啦！</p>
    <p class="desc-2">我要把{{ mainAwardInfo.award_name }} 0元带回家</p>
  </div>
</template>
<script>
import Swiper, { Autoplay } from 'swiper';
import ComAwardCard from '../components/com-award-card.vue';
import 'swiper/swiper-bundle.css';

Swiper.use(Autoplay);
export default {
  components: {
    ComAwardCard,
  },
  props: {
    awardList: {
      type: Array,
      default: () => [],
    },
    mainAwardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      this.my_swiper = new Swiper('.swiper', {
        initialSlide: 3,
        autoplay: {
          disableOnInteraction: false, //触碰后自动轮播也不会停止
          delay: 1000,
        },
        slidesPerView: 3,
        slidesPerview: 'auto',
        // width: 130,
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        loopedSlides: 3,
      });
    },
  },
};
</script>
<style lang="less">
.view-share-award {
  margin: 0 12px;
  padding: 18px 18px 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  text-align: left;
  .title {
    width: 100%;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: rgba(20, 25, 30, 1);
    text-align: center;
  }
  .swiper-outer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    height: 100px;
    background: rgba(250, 251, 252, 1);
    border-radius: 2px;
    overflow: hidden;
    border: 1px solid rgba(243, 244, 245, 1);
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 22px;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgb(243, 244, 245) 0%,
        rgba(243, 244, 245, 0) 100%
      );
      z-index: 100;
    }
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 22px;
      height: 100%;
      background: linear-gradient(
        270deg,
        #f3f4f5 0%,
        rgba(243, 244, 245, 0) 100%
      );
      z-index: 100;
    }
    .swiper {
      width: 406px;
    }
  }
  .desc-1 {
    margin-top: 18px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: rgba(20, 25, 30, 1);
  }
  .desc-2 {
    margin-top: 3px;
    font-size: 12px;
    line-height: 17px;
    color: rgba(20, 25, 30, 1);
  }
}
</style>
